export enum PaycardStatusEnum {
  VALID = 'VALID',
  INIT = 'INIT',
  UNKNOWN = 'UNKNOWN'
}
